import { moduleProviderFactory } from "core/providers";
import { NikoFacilityOrderList } from "application/niko-facility-order/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.niko-facility-order",
				pattern: "/niko-facility-orders",
                children: [
					{
						name: "master.app.main.niko-facility-order.list",
						pattern: "",
						tabTitle: 'MENU.NIKO_FACILITY_ORDERS',
						component: NikoFacilityOrderList,
						authorization: "administrationSection.read",
						data: {
							title: "MENU.NIKO_FACILITY_ORDERS",
						},
					}
                ]
            }
        ],
        menu: [
            {
				title: "MENU.FACILITY_ORDERS",
				icon: "package",
				authorization: "administrationSection.read",
				order: 5,
				subMenu: [
					{
						title: "MENU.NIKO_FACILITY_ORDERS",
						authorization: "administrationSection.read",
						route: "master.app.main.niko-facility-order.list",
						order: 3,
					}
				]
			},
        ]
    });
})();
